import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/buttons.css';
import App from './App';
import './styles/workspace.css';
import { checkAndClearStorage } from './shared/utils/versionControl';
import { initSentry } from './core/config/sentry';

initSentry();

const wasCleared = checkAndClearStorage();
if (wasCleared && window.location.pathname !== '/login') {
  window.location.href = '/login';
}

if (!wasCleared || window.location.pathname === '/login') {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
